module.exports = __webpack_public_path__ + "static/media/teach.96d51459.gif";